import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class PersonalProtectiveEquipmentProcedure extends Component {

    render() {
        const title = t('menu.support.p22');
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'personalProtective'}
            title={ title }
            exportTitle={`<h2>${title}</h2>`}
            exportFileName={'personal_protective.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PersonalProtectiveEquipmentProcedure);